import { render } from "./KalenderHalvaar.vue?vue&type=template&id=5540d42c"
import script from "./KalenderHalvaar.vue?vue&type=script&lang=js"
export * from "./KalenderHalvaar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__